// Centralised test ids
export const HOME = {
    emergentLink: "home-emergent-link",
};

export const NAV = {
    root: "navbar-root",
    logo: "navbar-logo",
    linkProduits: "nav-link-produits",
    linkOffres: "nav-link-offres",
    linkExpertise: "nav-link-expertise",
    linkComparatif: "nav-link-comparatif",
    linkProcessus: "nav-link-processus",
    linkFaq: "nav-link-faq",
    ctaQuote: "nav-cta-quote",
};

export const HERO = {
    root: "hero-root",
    title: "hero-title",
    sub: "hero-sub",
    ctaCatalog: "hero-cta-catalog",
    ctaOffers: "hero-cta-offres",
    ctaQuote: "hero-cta-quote",
};

export const QUOTE = {
    dialog: "quote-dialog",
    inputName: "quote-input-name",
    inputClinic: "quote-input-clinic",
    inputEmail: "quote-input-email",
    inputPhone: "quote-input-phone",
    inputCity: "quote-input-city",
    inputMessage: "quote-input-message",
    inputProduct: "quote-input-product",
    submit: "quote-submit",
    sendWhatsapp: "quote-send-whatsapp",
    openTrigger: "quote-open-trigger",
};

export const PRODUCTS = {
    section: "products-section",
    card: (id) => `product-card-${id}`,
    quoteBtn: (id) => `product-quote-${id}`,
};

export const FAQ = {
    section: "faq-section",
    item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
    root: "footer-root",
};

export const CART = {
    button: "nav-cart-button",
    badge: "nav-cart-badge",
    drawer: "cart-drawer",
    itemsList: "cart-items-list",
    item: (id) => `cart-item-${id}`,
    qty: (id) => `cart-qty-${id}`,
    plus: (id) => `cart-plus-${id}`,
    minus: (id) => `cart-minus-${id}`,
    remove: (id) => `cart-remove-${id}`,
    inputName: "cart-input-name",
    inputClinic: "cart-input-clinic",
    inputPhone: "cart-input-phone",
    inputCity: "cart-input-city",
    inputMessage: "cart-input-message",
    checkout: "cart-checkout-whatsapp",
    clear: "cart-clear",
};
